import { render, staticRenderFns } from "./PidTransactionRow.vue?vue&type=template&id=70ad2e24&scoped=true&"
import script from "./PidTransactionRow.vue?vue&type=script&lang=js&"
export * from "./PidTransactionRow.vue?vue&type=script&lang=js&"
import style0 from "./PidTransactionRow.vue?vue&type=style&index=0&id=70ad2e24&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad2e24",
  null
  
)

export default component.exports